/**
 * KineticText.tsx
 * 
 * Renders text with a staggered character-by-character entrance animation.
 * Characters slide up and fade in.
 */

import { motion } from 'framer-motion';

interface KineticTextProps {
    text: string;
    className?: string;
    delay?: number;
    stagger?: number;
    as?: React.ElementType; // h1, h2, span, etc.
}

export function KineticText({
    text,
    className = "",
    delay = 0,
    stagger = 0.05,
    as: Component = 'span'
}: KineticTextProps) {
    const letters = Array.from(text);

    return (
        <Component className={`inline-block whitespace-pre overflow-hidden ${className}`}>
            {letters.map((letter, i) => (
                <motion.span
                    key={i}
                    initial={{ y: "100%", opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{
                        delay: delay + (i * stagger),
                        duration: 0.5,
                        ease: [0.33, 1, 0.68, 1], // cubic-bezier for smooth pop
                    }}
                    className="inline-block"
                >
                    {letter}
                </motion.span>
            ))}
        </Component>
    );
}
